export const API = process.env.REACT_APP_TECNOFIN_URL_API;
export const InactivityTimeMiliseconds =
	process.env.REACT_APP_INACTIVITY_TIME_MILISECONDS || 600000;
export const EmpresaLogo = process.env.REACT_APP_LOGO_EMPRESA || "cartera365";
export const whiteListUrl = ["/preview-pdf", "*"];
